import { UpdateCotizacion } from "../../services/cotizacion";

export const saveInfoCotizacion = (body, setAlertCustom, refetch, refrescar = null) => {
  UpdateCotizacion(body)
    .then(() => {
      setAlertCustom({
        open: true,
        title: "Confirmacion",
        severity: "success",
        message: "Se guardo correctamente",
      });
      refrescar && refrescar();
      refetch();
    })
    .catch((error) => {
      setAlertCustom({
        open: true,
        title: "Error",
        severity: "error",
        message: error?.message,
      });
    });
}
export const NumeroOrdenDeMonedaMayor = (array) => {
  let todasLasOrdenDeMoneda = [];
  array?.map((item) => todasLasOrdenDeMoneda.push(Number(item.monedaOrden)));
  return Math.max(...todasLasOrdenDeMoneda);


}